import React from "react"
import { Search, X } from "lucide-react"
import type { StudentInfo } from "../../api/studentAuth"
import StudentLogo from "./StudentLogo"
import SearchField from "./SearchField"
import NotificationBell from "./NotificationBell"
import NewPracticePaperLink from "./NewPracticePaperLink"
import ProfileMenu from "./ProfileMenu"
import "./StudentHeader.style.scss"

interface StudentHeaderProps {
  student?: StudentInfo | null
  isSearchOpen: boolean
  onToggleSearch: () => void
  onCloseSearch: () => void
}

const StudentHeader = ({
  student,
  isSearchOpen,
  onToggleSearch,
  onCloseSearch,
}: StudentHeaderProps) => {
  return (
    <>
      <header className="student-header">
        <div className="student-header__left">
          <div className="student-header__mobile-logo">
            <StudentLogo size="lg" />
          </div>
          <div className="student-header__desktop-search">
            <SearchField onSubmitSearch={onCloseSearch} />
          </div>
        </div>

        <div className="student-header__right">
          <button
            type="button"
            className="student-header__mobile-search-toggle"
            onClick={onToggleSearch}
            aria-label="Toggle search"
            aria-expanded={isSearchOpen}
          >
            {isSearchOpen ? (
              <X className="student-header__toggle-icon" />
            ) : (
              <Search className="student-header__toggle-icon" />
            )}
          </button>

          <NewPracticePaperLink />
          <div className="student-header__divider" aria-hidden />
          <NotificationBell />
          <ProfileMenu student={student} />
        </div>
      </header>

      {isSearchOpen && (
        <div className="student-header__mobile-search">
          <SearchField
            autoFocus
            className="student-search-field--mobile"
            onSubmitSearch={onCloseSearch}
          />
        </div>
      )}
    </>
  )
}

export default StudentHeader
